import React from 'react';
import Card from "react-bootstrap/Card";

const ToggleIconLinkButton = ({ shouldDisplayFirstTag, toggleButton, firstTag, FirstIcon, secondTag, SecondIcon, linkClassName: propLinkClassName }) => {
  const linkClassName = propLinkClassName ? "link-button " + propLinkClassName : "link-button";
  return (
    shouldDisplayFirstTag ? (
      <Card.Link
        href="#0"
        className={linkClassName}
        onClick={toggleButton}
      >
        <FirstIcon />{` ${firstTag}`}
      </Card.Link>
    ) : SecondIcon ? (
      <Card.Link
        href="#0"
        className={linkClassName}
        onClick={toggleButton}
      >
        <SecondIcon />{` ${secondTag}`}
      </Card.Link>
    ) : null
  )
}

export default ToggleIconLinkButton;